module.exports = __webpack_public_path__ + "img/Hüte.d6b3224e.jpg";